export const termsTranslations = {
  lv: {
    title: 'Noteikumi un nosacījumi',
    descriptions: {
      personal: 'Jūsu personīgā konta lietošanas noteikumi un datu apstrādes politika.',
      institution: 'Iestādes vārdā apstiprinātie lietošanas noteikumi un datu apstrādes politika.',
      organization:
        'Organizācijas vārdā apstiprinātie lietošanas noteikumi un datu apstrādes politika.',
    },
    document: 'Dokuments',
    termsOfUse: 'Lietošanas noteikumi',
    dataPolicy: 'Datu apstrādes politika',
    currentVersion: 'Spēkā esošā versija: {{version}}',
    accepted: 'Apstiprināts',
    acceptedVersion: 'Versija {{version}}',
    status: 'Statuss',
    needsAcceptance: 'Jāapstiprina',
    needsRenewal: 'Jāapstiprina jaunā versija',
    unknownStatus: 'Statuss nav pieejams',
    unknownDate: 'Apstiprinājuma datums nav pieejams',
    notAccepted: 'Nav apstiprināts',
    unknownAcceptance: 'Apstiprinājuma dati nav pieejami',
    noDocuments: 'Nav dokumentu.',
    loadError: 'Neizdevās ielādēt noteikumus un nosacījumus',
    notice: 'Dažiem dokumentiem nepieciešams apstiprinājums.',
  },
  en: {
    title: 'Terms and conditions',
    descriptions: {
      personal: 'Terms of use and data processing policy for your personal account.',
      institution: 'Terms of use and data processing policy accepted on behalf of the institution.',
      organization:
        'Terms of use and data processing policy accepted on behalf of the organization.',
    },
    document: 'Document',
    termsOfUse: 'Terms of use',
    dataPolicy: 'Data processing policy',
    currentVersion: 'Current version: {{version}}',
    accepted: 'Accepted',
    acceptedVersion: 'Version {{version}}',
    status: 'Status',
    needsAcceptance: 'Acceptance needed',
    needsRenewal: 'Accept the new version',
    unknownStatus: 'Status unavailable',
    unknownDate: 'Acceptance date unavailable',
    notAccepted: 'Not accepted',
    unknownAcceptance: 'Acceptance details unavailable',
    noDocuments: 'No documents.',
    loadError: 'Could not load terms and conditions',
    notice: 'Some documents require acceptance.',
  },
}
